import { Icon } from "./Icon.tsx";

export function RenameIcon() {
  return (
    <Icon>
      <path d="M9 4h6M12 4v16M9 20h6" />
    </Icon>
  );
}
